module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vMhn4O/tc-custom/9780544177536.jpg?1740769992983",
      "alt": "This image is the cover for the book 20-Minute Meals, Betty Crocker Cooking"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("20-Minute Meals, Betty Crocker Cooking\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Quick & easy recipes to help you get dinner on the table fast with Betty Crocker.")])]), _vm._v(" If you think you don't have time to cook dinner tonight, think again! Inside, you'll find over 20 easy, delicious recipes that are ready in 20 minutes or less. And because they come from Betty Crocker, you can be sure they're good. So say goodbye to takeout pizza and frozen dinners—and say hello to tasty, healthy, home-cooked meals."), _c('br'), _c('br'), _vm._v(" For more great ideas visit bettycrocker.com \n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Betty Crocker\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0